import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type { ApiResponse } from '../types';
import type {
  CreateAnnouncementRequest,
  CreateAnnouncementResponse,
  ListAnnouncementsQuery,
  ListAnnouncementsResponse,
} from '../types/announcements';

export function bindAnnouncements(client: ApiClient) {
  return {
    async listAnnouncements(
      params?: ListAnnouncementsQuery
    ): Promise<ApiResponse<ListAnnouncementsResponse>> {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.module?.trim()) qs.set('module', params.module.trim());
      if (params?.audience?.trim()) qs.set('audience', params.audience.trim());
      if (params?.content_type?.trim()) qs.set('content_type', params.content_type.trim());
      const query = qs.toString();
      return client.request<ListAnnouncementsResponse>(
        query ? `/announcements?${query}` : '/announcements'
      );
    },

    async createAnnouncement(
      body: CreateAnnouncementRequest
    ): Promise<ApiResponse<CreateAnnouncementResponse>> {
      return client.request<CreateAnnouncementResponse>('/announcements', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
